import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  LOCALE_ID,
} from '@angular/core';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import moment from 'moment';

import { finalize, Observable, tap } from 'rxjs';
import { CustomDateAdapter } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-adapter';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { ServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-interfaces/api-interface-advisor-blocked-schedule';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';
import { APIService } from 'src/services/api-services/api-service';
import { advisor } from '../../../../../models/advisor';
import { AdvisorsComponent } from '../../advisors.component';
import { CUSTOM_DATE_FORMATS } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-formats';
import { CustomDatePickerHeader } from 'src/app/administration/workshops/dialogs/lock-settings/custom-date-picker-header/custom-date-picker-header';
import { deleteLockSettingsAdvisorDialog } from './delete-lock-settings-advisor/delete-lock-settings-advisor.dialog';
import { TranslateService } from '@ngx-translate/core';

import { HelperService } from 'src/services/helperService';
import { APIBlockedReason } from 'src/services/api-services/api-blocked-reason';

@Component({
    selector: 'app-lock-settings',
    templateUrl: './lock-settings-advisor.dialog.html',
    styleUrls: ['./lock-settings-advisor.dialog.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    ],
    standalone: false
})
export class LockSettingsDialogAdvisor {
  isActive: boolean = true;
  customDatePickerHeader = CustomDatePickerHeader;
  constructor(
    public brandsService: APIBrandsService,
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    @Inject(MAT_DIALOG_DATA) public advisor: advisor,
    public dialog: MatDialog,
    public AdvisorBlockedScheduleService: APIServiceAdvisorBlockedSchedule,
    public Service: APIService,
    private translate: TranslateService,

    @Inject(LOCALE_ID) public localeId: string,

    public helperService: HelperService,
    public lockedReasonService: APIBlockedReason
  ) {

  }
  ngOnInit(): void {
    this.StartDate = this.calendarTime;
    this.EndDate = this.calendarTime;
    this.StartHour = '1:00 AM';
    this.hourFinal = '11:30 PM';
    this.blockDay = true;
    this.blockHours = false;
    this.IntervalHours();
    this.diasSeleccionado = this.calendarTime.getDate();
  }
  test: boolean = false;
  BrandIdFilter: number = 0;
  BrandIdInitial: number | undefined = 0;
  loadBloqued: boolean = true;
  isHistoryLoading: boolean = false;
  CanEditData: boolean = false;
  brands: any[] = [];
  LockData: any = [];
  initialpage: boolean = true;
  IdbloquingReason: any = '';
  pagingTypeLocks: string = '';
  diasSeleccionado: any;
  public historialLocks: any[] = [];
  public DataLocks: any[] = [];
  public DataLocksf: any[] = [];
  fechas: any[] = [];
  services: ServiceSchedule[] = [];
  public calendarTime: Date = new Date();
  public StartDate: any = '';
  public EndDate: any = '';
  public StartHour: any = '1:00 A.M.';
  public hourFinal: any = '11:30 P.M.';
  blockDay: boolean = true;
  blockHours: boolean = false;
  refreshLoader: boolean = false;
  checkCopiBrandBloqued: boolean = false;
  indexBrands: number = 0;
  service: any = [];
  serviceAll: any[] = [];
  serviceCorrectSave: string[] = [];
  serviceIncorrectSave: string[] = [];
  typeOfServiceCopy: boolean = false;
  reasonAdvisors: any = [];
  dataInt: ServiceAdvisorBlockedSchedule = {
    description: '',
    dayOfWeek: '',
    hourInitial: '',
    hourFinal: '',
    isActive: false,
    serviceAdvisorBlockedServiceId: 1,
    initialDate: new Date(''),
    finalDate: new Date(''),
    optional: '',
    serviceAdvisorServiceId: 1,
    blockedReasonId: 0,
  };
  style1 = {
    background: '#16BAE7',
    ' border': 'solid 1px #16BAE7',
    color: '#fff',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  style2 = {
    background: '#fff ',
    ' border': 'solid 1px #16BAE7',
    color: '#16BAE7',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  style3 = {
    background: '#EBEEF2',
    border: 'solid 1px #EBEEF2 ',
    color: '#fff',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  style4 = {
    background: '#fff ',
    border: 'solid 1px #EBEEF2 ',
    color: '#EBEEF2',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'font-size': '16px',
    'font-family': 'sans-serif',
    'border-radius': '0',
  };
  timehours: any = [];

  // Funtios get for info data base

  getServiceAdvisor() {
    if (this.BrandIdFilter !== this.BrandIdInitial) {
      this.service = [
        ...this.serviceAll.filter(
          (response) => response.brandId === this.BrandIdFilter
        ),
      ];
      this.FilterDataLockForBrand();
    } else {
      this.Service?.getAdvisorAndbrand(this.advisor.advisorId)
        .pipe(
          tap((response) => {
            if (!response.message) {
              this.serviceAll = response.filter(
                (response) => response.isActive === true
              );
              this.service = [
                ...this.serviceAll.filter(
                  (response) => response.brandId === this.BrandIdFilter
                ),
              ];
            }
          }),
          finalize(() => this.SelectDateIntCalendar())
        )
        .subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        });
    }
  }
  getServiceBrand() {
    this.brandsService
      ?.getBrandAdvisor(this.advisor.advisorId)
      .pipe(
        tap((response) => {
          if (!response.message) {
            this.brands = response;
            this.brands[0].style = this.style1;
            this.BrandIdFilter = this.brands[0].brandId;
            this.BrandIdInitial = this.brands[0].brandId;
          }
        }),
        finalize(() => this.getAdvisorBlockedReason())
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  getAdvisorBlockedServicesHistorial() {
    this.isHistoryLoading = true;
    this.historialLocks = [];

    this.AdvisorBlockedScheduleService.getadvisorHistorialLocks(
      this.advisor.advisorId
    )
      .pipe(
        tap((response) => {
          if (!response.message) {
              this.historialLocks = this.formatHistory(response);
          }
        }),
        finalize(() => (this.isHistoryLoading = false))
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  getAdvisorBlockedReason() {
    if (this.BrandIdFilter !== this.BrandIdInitial) {
      this.getServiceAdvisor();
    } else {
      this.lockedReasonService
        .getByreasonAdvisor()
        .pipe(
          tap((response) => {
            if (!response.message) {
              this.reasonAdvisors = response;
            }
          }),
          finalize(() => this.getServiceAdvisor())
        )
        .subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        });
    }
  }
  // Funtion Filter For brand
  onApplyFilter(brand: any) {
    this.loadBloqued = false;
    if (brand.brandId) {
      this.BrandIdInitial = undefined;
      this.BrandIdFilter = brand.brandId;
    }

    this.getServiceAdvisor();
  }

  FilterDataLockForBrand() {
    this.loadBloqued = true;
    this.SelectDateIntCalendar();
  }
  // Funtions Show data

  IntervalHours() {
    let interval = moment.duration('00:15:00').asHours();
    const hourNumArr = moment.duration('01:00:00').asHours();
    const hourNumArrF = moment.duration('23:45:00').asHours();
    this.timehours = [];
    for (let i = hourNumArr; i < hourNumArrF; i += interval) {
      let time =
        ('0' + (Math.floor(i) % 24)).slice(-2) +
        ':' +
        ((i % 1) * 60 + '0').slice(0, 2);
      let amFormat = moment(time, 'HH:mm:ss').format('h:mm A');
      let hoursSplit = amFormat.split(' ');
      let replaceHours = hoursSplit[1].replace(
        hoursSplit[1],
        `${hoursSplit[0]} ${hoursSplit[1][0]}${hoursSplit[1][1]}`
      );
      this.timehours.push(replaceHours);
      this.timehours = [...new Set(this.timehours)];
    }
  }

  ButtonTypeconfigOrHistorial(type) {
    if (type === 'blocks') this.getServiceBrand();
    this.loadBloqued = false;
    this.pagingTypeLocks = type;
    this.initialpage = false;

    if (type === 'historial') this.getAdvisorBlockedServicesHistorial();
  }

  //  Metods config hours
  dateFilter = (date): boolean => {
    let hoy = new Date();
    let miliseg = 24 * 60 * 60 * 1000;

    if (date >= new Date(hoy.getTime() - miliseg)) {
      return true;
    } else {
      return false;
    }
  };

  dateFilterEnd = (date): boolean => {
    if (date >= this.StartDate) {
      return true;
    } else {
      return false;
    }
  };

  ChangeDateEnd() {
    if (this.StartDate > this.EndDate) {
      this.EndDate = this.StartDate;
    }
  }

  ChangeTypeBlock(StateBlock: boolean, TypeBlock: string) {
    // change state blocks in all day and hours
    if (StateBlock === false) {
      this.StartHour = '1:00 AM';
      this.hourFinal = '11:30 PM';
      this.blockDay = false;
    } else {
      this.StartHour = '1:00 AM';
      this.hourFinal = '11:30 PM';
      this.blockDay = true;
    }

    if (TypeBlock === 'Day') {
      if (StateBlock === false) {
        this.StartHour = '1:00 AM';
        this.hourFinal = '11:30 PM';
        this.blockHours = false;
      } else {
        this.StartHour = '1:00 AM';
        this.hourFinal = '11:30 PM';
        this.blockHours = true;
      }
    }
  }

  ChangeTypeofservice() {
    // (change) delivers the new value; legacy (click) saw the old one: checking turns every service on
    this.serviceAll.map((service) => (service.isActive = this.typeOfServiceCopy));
  }

  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

  private formatHistory(history: any[]): any[] {
    return history.map((lock) => ({
      ...lock,
      serviceNamesArray: lock.serviceName
        ? lock.serviceName.split(',').map((service) => service.trim())
        : [],
      initialDateBlockedServices: moment(
        lock.initialDateBlockedServices
      ).format('DD/MM/YYYY'),
      finalDateBlockedServices: moment(lock.finalDateBlockedServices).format(
        'DD/MM/YYYY'
      ),
      hourInitialBlockedServices: moment(
        lock.hourInitialBlockedServices,
        'HH:mm:ss'
      ).format('h:mm A'),
      hourFinalBlockedServices: moment(
        lock.hourFinalBlockedServices,
        'HH:mm:ss'
      ).format('h:mm A'),
    }));
  }

  ValidationOfCorrectHours(): boolean {
    let hour = moment(this.StartHour, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    hour = moment(this.hourFinal, 'h:mm A').format('HH:mm:ss');
    split = hour.split(':');
    let hour_final_validacion = Number(split[0] + split[1]);
    let isvisible = true;
    if (hour_inicial_validacion < hour_final_validacion) {
      //if any filter is filled the button will be enabled
      isvisible = false;
    }
    return isvisible;
  }

  issaveDisabled(): boolean {
    // function to enable clear button conditionally
    let hour = moment(this.StartHour, 'h:mm A').format('HH:mm:ss');
    let split = hour.split(':');
    let hour_inicial_validacion = Number(split[0] + split[1]);
    (hour = moment(this.hourFinal, 'h:mm A').format('HH:mm:ss')),
      (split = hour.split(':'));
    let hour_final_validacion = Number(split[0] + split[1]);
    let isDisabled = true;
    if (
      this.StartDate !== '' &&
      this.EndDate !== '' &&
      hour_inicial_validacion < hour_final_validacion &&
      this.service.filter((service) => service.isActive === true).length > 0 &&
      this.IdbloquingReason !== ''
    ) {
      //if any filter is filled the button will be enabled
      isDisabled = false;
    }
    return isDisabled;
  }

  // Funtions for show data correct in the calendar
  SelectDateIntCalendar() {
    this.CanEditData = false;
    this.LockData = [];
    this.service.forEach((service) => {
      service.isActive = false;
    });
    this.loadBloqued = true;

    let content2: HTMLElement = document.getElementById(
      'activarOrdenes'
    ) as HTMLElement;
    content2.click();
  }

  review_date(LockSelect: any) {
    let DateStart = LockSelect.initialDate;
    let DateEnd = LockSelect.finalDate;
    if (DateStart !== DateEnd) {
      DateStart = DateStart.toString().split('/');
      DateEnd = DateEnd.toString().split('/');
      for (let i = Number(DateStart[0]) + 1; i < Number(DateEnd[0]); i++) {
        let valided = this.DataLocks.filter(
          (s) => s.optional === i + '/' + DateStart[1] + '/' + DateStart[2]
        );
        if (valided.length === 0) {
          this.DataLocks[this.DataLocks.length] = {
            description: LockSelect.description,
            dayOfWeek: LockSelect.dayOfWeek,
            hourInitial: LockSelect.hourInitial,
            hourFinal: LockSelect.hourFinal,
            isActive: LockSelect.isActive,
            serviceAdvisorBlockedServiceId:
              LockSelect.serviceAdvisorBlockedServiceId,
            initialDate: LockSelect.initialDate,
            finalDate: LockSelect.finalDate,
            optional: i + '/' + DateStart[1] + '/' + DateStart[2],
            serviceAdvisorServiceId: LockSelect.serviceAdvisorServiceId,
          };
        }
      }
    }
  }

  reviewdata(date: Date) {
    let LockData: any = [];
    LockData = this.DataLocks.filter(
      (s) =>
        s.initialDate === date.toLocaleDateString() && s.optional === undefined
    );
    LockData.forEach((LocksDatesSelect) => {
      this.review_date(LocksDatesSelect);
    });
  }

  public isMeeting(date: Date) {
    if (this.DataLocks.length !== 0) {
      this.reviewdata(date);
      let InitialDateFilter = this.DataLocks.map((s) => s.initialDate);
      let FinalDateFilter = this.DataLocks.map((s) => s.finalDate);
      let OptionalDateFilter = this.DataLocks.map((s) => s.optional);

      InitialDateFilter = InitialDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      FinalDateFilter = FinalDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      OptionalDateFilter = OptionalDateFilter.filter(
        (s) => s === date.toLocaleDateString()
      );
      if (
        InitialDateFilter.length !== 0 ||
        FinalDateFilter.length !== 0 ||
        OptionalDateFilter.length !== 0
      ) {
        return true ? 'meeting' : '';
      } else {
        return false ? 'meeting' : '';
      }
    } else {
      return false ? 'meeting' : '';
    }
  }

  // Funtions save and edit
  onCancel(): void {
    this.dialogRef.close();
  }

  onsave(): void {
    this.loadBloqued = false;
    let date = this.StartDate.toLocaleDateString();
    let date_end = this.EndDate.toLocaleDateString();

    if (!this.checkCopiBrandBloqued) {
      this.service.forEach((service) => {
        if (service.isActive === true && this.CanEditData === false) {
          this.post_put(
            this.LockData[0],
            1,
            Number(service.serviceAdvisorServiceId),
            service.isActive,
            service.serviceName
          );
        } else {
          if (
            this.LockData.serviceAdvisorBlockedServiceId !== undefined &&
            service.isActive === this.LockData.isActive &&
            service.serviceAdvisorServiceId ===
              this.LockData.serviceAdvisorServiceId
          ) {
            this.post_put(
              this.LockData,
              0,
              Number(service.serviceAdvisorServiceId),
              service.isActive,
              service.serviceName
            );
          } else if (
            this.LockData.serviceAdvisorBlockedServiceId === undefined &&
            service.isActive === true
          ) {
            this.post_put(
              this.LockData,
              1,
              Number(service.serviceAdvisorServiceId),
              service.isActive,
              service.serviceName
            );
          }
        }
      });
    } else {
      let servicesActive = [...this.service];
      servicesActive.forEach((serviceActive, i) => {
        let serviceAllFilter = [
          ...this.serviceAll.filter(
            (s) => s.serviceId === serviceActive.serviceId
          ),
        ];
        for (let j = 0; j < serviceAllFilter.length; j++) {
          if (this.service[i].isActive === true && this.CanEditData === false) {
            this.post_put(
              this.LockData[this.LockData.length - 1],
              1,
              Number(serviceAllFilter[j].serviceAdvisorServiceId),
              this.service[i].isActive,
              this.service[i].serviceName
            );
          } else {
            if (
              this.LockData.serviceAdvisorBlockedServiceId !== undefined &&
              this.service[i].isActive === this.LockData.isActive &&
              this.service[i].serviceAdvisorServiceId ===
                this.LockData.serviceAdvisorServiceId
            ) {
              this.post_put(
                this.LockData,
                0,
                Number(serviceAllFilter[j].serviceAdvisorServiceId),
                this.service[i].isActive,
                this.service[i].serviceName
              );
            } else if (
              this.LockData.serviceAdvisorBlockedServiceId === undefined &&
              this.service[i].isActive === true
            ) {
              this.post_put(
                this.LockData,
                1,
                Number(serviceAllFilter[j].serviceAdvisorServiceId),
                this.service[i].isActive,
                this.service[i].serviceName
              );
            }
          }
        }
      });
    }

    setTimeout(() => {
      if (this.serviceCorrectSave.length > 0) {
        const translateText = this.translate.instant('ToastBlockWorkshop');
        this.helperService.showAlert =true
        this.helperService.typeAlert ="success"
        this.helperService.messageAlert =translateText
        setTimeout(() => {
          this.helperService.showAlert =false
        }, 7000)
        this.dialogRef.close('NewData');
      }
      if (this.serviceIncorrectSave.length > 0) {
        const translateTex = this.translate.instant(
          'ToastBlockWorkshopDontSave',
          {
            service: [...new Set(this.serviceIncorrectSave)],
          }
        );
        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateTex
        setTimeout(() => {
          this.helperService.showAlert =false
        }, 7000)
      }
      this.dialogRef.close();
    }, 2000);
  }
  post_put(
    service: any,
    mode: number,
    serviceid: number,
    isActive: boolean,
    serviceName: string
  ) {
    if (mode === 0) {
      let dataint: ServiceAdvisorBlockedSchedule = {
        hourInitial: moment(this.StartHour, 'h:mm A').format('HH:mm:ss'),
        hourFinal: moment(this.hourFinal, 'h:mm A').format('HH:mm:ss'),
        isActive: isActive,
        serviceAdvisorBlockedServiceId: service.map(
          (s) => s.serviceAdvisorBlockedServiceId
        )[0],
        initialDate: moment(this.StartDate).format('YYYY-MM-DD'),
        finalDate: moment(this.EndDate).format('YYYY-MM-DD'),
        serviceAdvisorServiceId: serviceid,
        blockedReasonId: this.IdbloquingReason,
      };

      this.AdvisorBlockedScheduleService?.put(dataint).subscribe();
    } else if (mode === 1) {
      let dataint: ServiceAdvisorBlockedSchedule = {
        description: 'Bloqued',
        dayOfWeek: 'Blo',
        hourInitial: moment(this.StartHour, 'h:mm A').format('HH:mm:ss'),
        hourFinal: moment(this.hourFinal, 'h:mm A').format('HH:mm:ss'),
        isActive: isActive,
        serviceAdvisorBlockedServiceId: 0,
        initialDate: moment(this.StartDate).format('YYYY-MM-DD'),
        finalDate: moment(this.EndDate).format('YYYY-MM-DD'),
        optional: undefined,
        serviceAdvisorServiceId: serviceid,
        blockedReasonId: this.IdbloquingReason,
      };

      this.AdvisorBlockedScheduleService?.post(dataint)
        .pipe(
          tap((response) => {
            if (response.message) {
              this.serviceIncorrectSave.push(
                this.translate.instant(serviceName)
              );
            } else {
              this.serviceCorrectSave.push(this.translate.instant(serviceName));
            }
          })
        )
        .subscribe({
          error: (failed) => {
            // Validation 401 error
            if(failed.status === 401){
              this.helperService.logoutToken()
            }

            console.log(failed);

            this.serviceIncorrectSave.push(this.translate.instant(serviceName));
          },
        });
    }
  }
  // Funtions Historial locks

  EditLookSetting(lockSelected) {
    let date = lockSelected.initialDate.split('/');
    this.calendarTime = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    this.StartDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    date = lockSelected.finalDate.split('/');
    this.EndDate = new Date(date[1] + '/' + date[0] + '/' + date[2]);
    this.LockData = lockSelected;
    // this.pagingTypeLocks = false;
    this.CanEditData = true;
    this.StartHour = lockSelected.hourInitial;
    this.hourFinal = lockSelected.hourFinal;
    if (this.StartHour === '1:00 A.M.' && this.hourFinal === '11:30 P.M.') {
      this.blockDay = true;
      this.blockHours = false;
    } else {
      this.blockDay = false;
      this.blockHours = true;
    }

    for (let j = 0; j < this.service.length; j++) {
      if (
        lockSelected.serviceAdvisorServiceId ===
        this.service[j].serviceAdvisorServiceId
      ) {
        this.service[j].isActive = lockSelected.isActive;
      }
    }
  }
  onDeleteAdvisorClick(lockSelected) {
    this.dialogRef.close();
    lockSelected.advisorId = this.advisor.advisorId;
    lockSelected.advisorFullName = this.advisor.advisorName;
    lockSelected.initialDate = moment(
      lockSelected.initialDateBlockedServices,
      'DD/MM/YYYY'
    ).format('YYYY-MM-DD');
    lockSelected.finalDate = moment(
      lockSelected.finalDateBlockedServices,
      'DD/MM/YYYY'
    ).format('YYYY-MM-DD');
    lockSelected.hourInitial = moment(
      lockSelected.hourInitialBlockedServices,
      'h:mm A'
    ).format('HH:mm:ss');
    lockSelected.hourFinal = moment(
      lockSelected.hourFinalBlockedServices,
      'h:mm A'
    ).format('HH:mm:ss');

    const dialogRef = this.dialog.open(deleteLockSettingsAdvisorDialog, {
      width: '600px',
      panelClass: 'icon-outside',
      data: lockSelected,
    });
  }
}
